import { createSelector } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { baseApi } from './base';
import { FeatureFlags } from '../domain/config';
import { getOrCreateLocalStorage } from '../general/utils/localStorage';

const FEATURE_FLAGS_CONTEXT_KEY = 'x-coast-apply-feature-flags-context-key';

export const featuresApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<FeatureFlags, void>({
      query: () => {
        const anonymousContextKey = getOrCreateLocalStorage(FEATURE_FLAGS_CONTEXT_KEY, () => uuidv4());

        return {
          method: 'GET',
          url: `qualification/config/features?anonymous_context_key=${anonymousContextKey}`,
        };
      },
    }),
  }),
});

const selectFeatureFlagsResult = featuresApi.endpoints.getFeatureFlags.select();

export const selectAllFeatureFlags = createSelector([selectFeatureFlagsResult], (featureFlag) => featureFlag.data);

export const { useGetFeatureFlagsQuery } = featuresApi;
